import React, { useState, useRef, useEffect } from 'react';
import './InlineEdit.css';

export default function InlineEdit({ value, onSave, tag: Tag = 'span', className = '', editable = false }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    setDraft(value);
  }, [value]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const handleDoubleClick = () => {
    if (!editable) return;
    setEditing(true);
    setDraft(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      save();
    }
    if (e.key === 'Escape') {
      setEditing(false);
      setDraft(value);
    }
  };

  const save = () => {
    setEditing(false);
    if (draft !== value) {
      onSave(draft);
    }
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        className={`inline-edit__input ${className}`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={save}
      />
    );
  }

  return (
    <Tag
      className={`${className} ${editable ? 'inline-edit__display' : ''}`}
      onDoubleClick={handleDoubleClick}
      title={editable ? 'Double-click to edit' : undefined}
    >
      {value}
    </Tag>
  );
}
